import styled from 'styled-components';
import { Row } from "components/Layout/Grid";
import { colors } from 'pages/Quotes/styles/colors';

export const PaymentTermModalBg = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px !important;
`;

export const PaymentTermModalContent = styled.div`
  border-radius: 8px !important;
  width: 531px;
  padding: 18px;

  .modaLoader{
    height: 440px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const PaymentTermModalHeader = styled.div`
  height: 44px;
  margin-bottom: 15px;
  border-bottom: 1px #BEBEBE solid;
`;

export const PaymentTermModalItensInfo = styled.div`    
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px #BEBEBE solid;

  .itemIndicators{
    display: flex;
    justify-content: space-between;
  }

  .itemInfoTitle{
    margin-bottom: 15px;
    p{
      font-size: 14px !important;
      color: #0E4C54;
      font-weight: 700;
    }
  }

  .itemIndicatorTitle{
    font-size: 10px !important;
    color: #0E4C54;
    margin-bottom: 3px;
  }
  .itemIndicatorNumber{
    font-size: 24px !important;
    font-weight: 900;
  }
`;

export const PaymentTermModalPaymentTerm = styled.div`
  border-bottom: 1px #BEBEBE solid;
  padding-bottom: 15px;
  
    .paymentTermTitle{
      display: flex;
      justify-content: space-between;
      margin-bottom: 3px;

      p{
        font-size: 14px !important;
        color: #0E4C54;
        font-weight: 700;
      }
    }

  .paymentTermValue{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    p{
      font-size: 12px !important;
      color: #858585;
    }
  }

  .paymentTermLabels{
    display: grid;
    grid-template-columns: 50px 195px 176px auto;
    margin-bottom: 12px;

    label{
      font-weight: 600;
      font-size: 12px;
      color: #858585;
    }
  }

  .sameValueToggle{
    display: flex;
    align-items: center;

    label{
      margin-left: 8px;
      color:#364863;
    }
  }

  .notDownloaded{
    margin-bottom: 4px;
    span{      
      color: #E02828;
      margin-bottom: 10px;
    }
  }
`;

export const ModalContainer = styled.div`
  padding: 0;

  .email{
    color: #364863;
  }
`;

export const Header = styled(Row)`
  align-items: center;
  justify-content: space-between !important;
  flex-grow: 1;
`;


export const HeaderTitle = styled.p<{ fontWeight?: string, }>`
  text-transform: uppercase;
  color: ${colors.viveoDarkBlue};
  font-weight: 700;
  font-size: 14px;
`;

export const HeaderText = styled.div<{ fontWeight?: string, lineHeight?: string, style?: any, contrast?: boolean; }>`
  color: ${colors.mfDarkGrey};
  font-weight: ${props => props.fontWeight || 400};
  line-height: ${props => props.lineHeight || '16px'};
  font-style: normal;
  
  
  & em {
    font-weight: bold;
    font-style: normal;
    color: ${colors.viveoDarkBlue};
  }

  font-weight: ${props => props.contrast ? 700 : ''};
  color: ${props => props.contrast ? colors.viveoDarkBlue : ''};

`;

export const InfoImg = styled.img`
  vertical-align: middle;
  width: 12.8px;
  height: 12.8px;
`;